import request from '@/utilities/request';
import { countDown } from '@/utilities/index';

export default {
  async sendAccountVerificationCode({ commit, state, rootState }, reqBody) {
    commit('setIsCodeSentFail', false);

    window.clearInterval(state.counter);
    commit('setCounter', null);
    commit('setIsCountDowning', true);
    commit('setCoundownSec', 120);

    let counter;

    let recaptchaToken = '';

    try {
      recaptchaToken = await state.recaptcha.execute('sendAccountVerificationCode');
    } catch (error) {
      // ignore
    }

    request
      .post('/signin/module.php/tmauth/verifysendcode', {
        recaptchaToken,
        locale: rootState.userLang,
        ...reqBody,
      })
      .then(() => {
        counter = countDown(
          120,
          (sec) => {
            commit('setCoundownSec', sec);
          },
          () => {
            commit('setIsCountDowning', false);
          },
        );

        commit('setCounter', counter);
      })
      .catch(() => {
        if (counter) {
          window.clearInterval(counter);
          commit('setCounter', null);
        }

        commit('setIsCountDowning', false);
        commit('setIsCodeSentFail', true);
      });
  },
  async verifyAccountVerificationCode({ commit, state, dispatch, rootState }, reqBody) {
    commit('setIsVerifying', true);
    commit('setEmailVerificationCodeError', '');

    let recaptchaToken = '';

    try {
      recaptchaToken = await state.recaptcha.execute('verifyAccountVerificationCode');
    } catch (error) {
      // ignore
    }

    return new Promise(function (resolve, reject) {
      request
        .post('/signin/module.php/tmauth/verifyverifycode', {
          recaptchaToken,
          ...reqBody,
        })
        .then((res) => {
          commit('setIsVerifying', false);
          window.clearInterval(state.counter);
          commit('setCounter', null);
          dispatch(
            'triggerEvent',
            { eventName: `VerifyEmailVerificationCodeSuccess` },
            { root: true },
          );
          commit('setEmailVerificationCode', reqBody.verify_otp_code);

          resolve(res.data);
        })
        .catch((err) => {
          commit('setIsVerifying', false);
          if (err?.response?.status === 403) {
            commit('setEmailVerificationCodeError', state.lang.incorrectCode);
          } else {
            commit('setEmailVerificationCodeError', rootState.lang.error_msg.common);
          }

          dispatch(
            'triggerEvent',
            {
              eventName: `VerifyEmailVerificationCodeNG`,
              addInfo: {
                http_code: err?.response?.status,
              },
            },
            { root: true },
          );

          reject(err);
        });
    });
  },
  verifyAccountLater({ state }) {
    return request.post('/signin/module.php/tmauth/skipverifycode', { email: state.emailAddr });
  },
};
